import L from "leaflet";

// One divIcon instance per (status, color) pair is enough for any given theme/session,
// so we never rebuild the SVG/L.divIcon while markers re-render.
const iconCache = new Map();

const buildDivIcon = color => {
  const svg = `
    <svg width="26" height="36" viewBox="0 0 26 36" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 0C5.8 0 0 5.8 0 13c0 9.75 13 23 13 23s13-13.25 13-23C26 5.8 20.2 0 13 0z"
        fill="${color}"
        stroke="#ffffff"
        stroke-width="1.5"
      />
      <circle cx="13" cy="13" r="5" fill="#ffffff" />
    </svg>
  `;

  return L.divIcon({
    html: svg,
    className: "device-map-marker",
    iconSize: [26, 36],
    iconAnchor: [13, 36],
    popupAnchor: [0, -32]
  });
};

export const getDeviceMarkerIcon = (status, color) => {
  const cacheKey = `${status}:${color}`;

  if (!iconCache.has(cacheKey)) {
    iconCache.set(cacheKey, buildDivIcon(color));
  }

  return iconCache.get(cacheKey);
};
